import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IEecsWhiteList, IEecsWhiteListModal } from '../types';

interface InitialState extends BaseDataReducerInitialState<IEecsWhiteList> {
  currentModal: IEecsWhiteListModal | null;
  selectedWhiteList: IEecsWhiteList | null;
}

const { initialState, AC, reducer } = basedDataReducer<IEecsWhiteList, InitialState>('eecs-white-list');

const eecsWhiteListInitialState: InitialState = {
  ...initialState,
  currentModal: null,
  selectedWhiteList: null,
};

export const eecsWhiteList = createSlice({
  name: 'eecsWhiteList',
  initialState: eecsWhiteListInitialState,
  reducers: {
    setSelectedWhiteList: (state, action: PayloadAction<IEecsWhiteList | null>) => {
      state.selectedWhiteList = action.payload;
    },
    setWhiteListModal: (state, action: PayloadAction<IEecsWhiteListModal | null>) => {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as InitialState, action);
    });
  },
});
export const EecsWhiteListAC = AC;

export const { setWhiteListModal, setSelectedWhiteList } = eecsWhiteList.actions;
